module.exports = __webpack_public_path__ + "static/media/rain.1f770b84.svg";